import { defineRoute } from '../defineRoute';

export type TermsAndConditionsRouteParams = {
  // ...
};

export type TermsAndConditionsRouteParamsString = {
  // ...
};

export const TermsAndConditions = defineRoute<
  TermsAndConditionsRouteParams,
  TermsAndConditionsRouteParamsString
>({
  pathname: '/terms-conditions',
  nlPathname: '/algemene-voorwaarden',
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
